import { writable } from 'svelte/store';

export const curRoute = writable('/');
export const user = writable(undefined);
export const profileData = writable(undefined);
export const activeTab = writable(0);
export const checkPWA = writable({
    isMobile: false,
    deferredPrompt: null,
    instructionsToShow: null
})
export const createModal = writable({
    visible: false,
    initialInput: {
        docId: null,
        title: '',
        text: '',
        media: '',
        absolutePath: ''
    }
});

export const ideas = writable({
    newest: {
        query: null,
        entries: {},
        updates: {}
    },
    highlights: {
        query: null,
        entries: {},
        updates: {}
    },
    popular: {
        query: null,
        entries: {},
        updates: false
    }
});

export const stackIndex = writable({
    newest: 0,    
    highlights: 0,    
    popular: 0
})

export const currentDalleImages = writable({
    query: '',
    images: [],
    currentlySelected: null
})

export const restart = writable(false);

export const modalCanUseHistoryBack = writable(false);